package com.example.positionahead.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.example.positionahead.model.Recommendation
import com.example.positionahead.model.RecommendationAction
import com.example.positionahead.ui.theme.gainColor
import com.example.positionahead.ui.theme.lossColor

@Composable
fun RecommendationCard(
    recommendation: Recommendation,
    modifier: Modifier = Modifier,
) {
    val accentColor = when (recommendation.action) {
        RecommendationAction.BUY -> gainColor
        RecommendationAction.SELL -> lossColor
        RecommendationAction.REBALANCE -> MaterialTheme.colorScheme.secondary
        RecommendationAction.HOLD -> MaterialTheme.colorScheme.onSurfaceVariant
    }

    Box(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(16.dp))
            .background(accentColor.copy(alpha = 0.05f))
            .padding(16.dp)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(16.dp),
            verticalAlignment = Alignment.Top
        ) {
            ActionBadge(action = recommendation.action, color = accentColor)
            Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                Text(
                    text = recommendation.title,
                    style = MaterialTheme.typography.titleSmall,
                    fontWeight = FontWeight.Black,
                )
                Text(
                    text = recommendation.detail,
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    lineHeight = androidx.compose.ui.unit.TextUnit.Unspecified,
                )
                recommendation.tradeSummary()?.let { tradeLine ->
                    Text(
                        text = tradeLine,
                        style = MaterialTheme.typography.labelMedium,
                        fontWeight = FontWeight.Bold,
                        color = accentColor,
                    )
                }
            }
        }
    }
}

@Composable
private fun ActionBadge(action: RecommendationAction, color: androidx.compose.ui.graphics.Color) {
    val label = when (action) {
        RecommendationAction.BUY -> "SIGNAL"
        RecommendationAction.SELL -> "ALERT"
        RecommendationAction.HOLD -> "NOTICE"
        RecommendationAction.REBALANCE -> "ADJUST"
    }
    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(6.dp))
            .background(color)
            .padding(horizontal = 8.dp, vertical = 4.dp)
    ) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelSmall,
            color = colorOn(color),
            fontWeight = FontWeight.ExtraBold,
        )
    }
}

@Composable
private fun colorOn(color: androidx.compose.ui.graphics.Color): androidx.compose.ui.graphics.Color {
    return if (color == gainColor || color == lossColor || color == MaterialTheme.colorScheme.secondary) {
        androidx.compose.ui.graphics.Color.White
    } else {
        MaterialTheme.colorScheme.onSurface
    }
}
